<template>
  <div class="validate-home-page">
    <detail ref="postDetail"></detail>
  </div>
</template>

<script>
import Detail from "../../components/media/schedule/detail/Detail";
import { getPostBy } from "../../service/post";
import { Post } from "../../service/model/post";
import { showErrorMsg } from "../../utils/errors";
import moment from "moment-timezone";
export default {
  name: "ValidateHomePage",
  components: { Detail },
  async mounted() {
    const loading = this.$loading();
    try {
      const token = this.$route.params.token;
      const form = await getPostBy({ token });
      // 判断当前状态是否有问题
      if (form.reviewing_status === 2) {
        this.$router.replace({
          name: "ValidateDownloadPage",
          query: { type: "approve", username: form.user.social_username },
        });
        return;
      }
      if (form.reviewing_status === 3) {
        this.$router.replace({
          name: "ValidateDownloadPage",
          query: { type: "decline", username: form.user.social_username },
        });
        return;
      }
      if (moment(form.post_time).isBefore(moment())) {
        this.$router.replace({
          name: "ValidateDownloadPage",
          query: { msg: "This schedule is expired." },
        });
        return;
      }
      // 格式化获取的详情信息
      const detail = new Post(form);
      detail.validate = true;
      this.$refs.postDetail.show(detail);
    } catch (e) {
      if (e.errorCode === 4404) {
        this.$router.replace({
          name: "ValidateDownloadPage",
          query: {
            msg: "This link is expired. Please ask the sender to send a new link.",
          },
        });
        return;
      }
      showErrorMsg(e);
    } finally {
      loading.close();
    }
  },
};
</script>

<style lang="less" scoped>
.validate-home-page {
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
